<template>
  <div class='h-outTabs'>
    <div id='nsiTable' class='h100vh-140'>
      <NSIMenu @methodEnum='methodEnum'></NSIMenu>
      <NSITable ref="nsiTable"></NSITable>
    </div>
  </div>
</template>
<script>
import NSIMenu from './NSIMenu';
import NSITable from './NSITable';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'nsiList',
  components: {
    NSIMenu,
    NSITable
  },
  data() {
    return {
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'refresh':
          this.$refs.nsiTable.page.pageNo = "1";
          this.$refs.nsiTable.getNSIListData();
          break;
        case 'activate':
          this.$refs.nsiTable.activateNSI();
          break;      
        case 'deactivate':
          this.$refs.nsiTable.deactivateNSI();
          break; 
        case 'delete':
          this.$refs.nsiTable.deleteNSI();
          break;  
        case 'monitor':
          this.$refs.nsiTable.monitorNSI();
          break;        
        default:
      }
    }
  },
  mounted() {
  }
};
</script>
